import clsx from "clsx";
import s from "./ResetCode.module.scss";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import OtpInputs from "../../../../global components/OtpInputs";
import { useQuery } from "../../../../libs/common";
import useSWRMutation from "swr/mutation";
import {
  parseClientError,
  swrMutationFetcher,
  SwrMutationFetcherArgType,
} from "../../../../libs/api/Endpoints";
import Navigation from "../../../../global components/Navigation/Navigation";
import { generateResult } from "../../../../global components/ResultModal/ResultModal";
import { SuccessDataType } from "../../../../libs/api/types";

function ResetCode() {
  const navigate = useNavigate();
  const query = useQuery();
  const email = query.get("email");
  const { trigger: enterEmail } = useSWRMutation(
    "api/admin/auth/forgot-password",
    swrMutationFetcher,
  );
  const { trigger: verifyOTP, isMutating } = useSWRMutation(
    "api/admin/auth/verify-reset-code",
    swrMutationFetcher,
  );
  const handleResendOTP = async () => {
    try {
      const fetchArg: SwrMutationFetcherArgType = {
        requestOption: {
          body: JSON.stringify({ email }),
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
      };
      await enterEmail(fetchArg);

      generateResult("success", "OTP Sent");
    } catch (error) {
      const e = parseClientError(error);
      generateResult(
        "error",
        e.message.charAt(0).toUpperCase() + e.message.slice(1) || e.error,
      );
    }
  };
  const handleOtpSubmit = async (otp: string) => {
    try {
      const fetchArg: SwrMutationFetcherArgType = {
        requestOption: {
          body: JSON.stringify({ email, otp }),
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
      };
      const response: SuccessDataType<{ resetToken: string }> =
        await verifyOTP(fetchArg);

      navigate("/auth/reset-password", {
        state: { token: response.data.resetToken},
      });
      generateResult("success", "Reset your password");
    } catch (error) {
      const e = parseClientError(error);
      generateResult(
        "error",
        e.message.charAt(0).toUpperCase() + e.message.slice(1) || e.error,
      );
    }
  };
  return (
    <div className={s.wrapper}>
      <div className={s.navigate}>
        <Navigation />
      </div>
      <div className={s.mainContent}>
        <span className={s.titles}>
          <h3 className={s.title}>Reset code</h3>
          <p className={s.subtitle}>
            Provide the code that was sent to {email}
          </p>
        </span>
        <div className={clsx(s.form)}>
          <OtpInputs
            numInputs={6} // Number of OTP inputs
            handleSubmit={handleOtpSubmit} // Your submit function
            otpLengthCheck={4} // Optional check for OTP length
            errorMessage="Please enter the complete OTP"
            buttonLabel="Continue"
            loading={isMutating}
            buttonClassName={s.button} // Pass custom button class if needed
          />
        </div>
        <div className={s.createAccount}>
          <p>
            Did not get the code? &nbsp;
            <span onClick={handleResendOTP} className={s.links}>
              Resend code
            </span>
            &nbsp; or &nbsp;
            <Link to="/auth/forgot-password" className={s.links}>
              Change email
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ResetCode;
